const WHATSAPP_NUMBER = '+923348872555';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}`;
const PHONE_URL = `tel:${WHATSAPP_NUMBER}`;

export default function FinalCTA() {
  return (
    <section className="relative w-full py-20 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxury%20modern%20residential%20community%20at%20night%20with%20warm%20lights%20green%20landscaping%20and%20modern%20houses%20aerial%20view%20Islamabad%20Pakistan%20premium%20real%20estate%20dramatic%20lighting%204k%20cinematic&width=1920&height=800&seq=601&orientation=landscape"
          alt="Property Investment"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-charcoal-400/75" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <span className="inline-block text-xs md:text-sm font-semibold text-brand-orange uppercase tracking-widest mb-4">
          Start Your Journey
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-5 max-w-3xl mx-auto">
          Let&apos;s Find Your Next Property Investment
        </h2>
        <p className="text-base md:text-lg text-ivory-300 mb-10 max-w-xl mx-auto">
          Expert guidance, verified projects, and transparent processes — everything you need for a confident investment decision.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-8 py-4 bg-brand-orange text-white text-base md:text-lg font-bold rounded-xl hover:bg-brand-orangeLight transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-2"
          >
            <i className="ri-whatsapp-line text-xl" />
            WhatsApp Now
          </a>
          <a
            href={PHONE_URL}
            className="w-full sm:w-auto px-8 py-4 border-2 border-white/40 text-white text-base md:text-lg font-bold rounded-xl hover:bg-white/10 hover:border-white/60 transition-all duration-300 flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line text-xl" />
            Call {WHATSAPP_NUMBER}
          </a>
        </div>
      </div>
    </section>
  );
}